// Replaces the default "PhotonPE" brand token in static copy with the active
// white-label company name (case-preserving for the uppercase variant).
export const brandText = (text, name) => {
  if (!text || !name || name === "PhotonPE") return text;
  return String(text)
    .replace(/PHOTONPE/g, name.toUpperCase())
    .replace(/PhotonPE/g, name);
};
